import React from 'react';
import { weekRangeLabel } from '../utils';

const WeekNav = ({ interval, label, onPrev, onNext, onToday, prevLabel = 'Назад', nextLabel = 'Вперёд', todayLabel = 'Сегодня' }) => (
    <div className="pc-sched-wk">
        <button type="button" onClick={onPrev} aria-label={prevLabel}>‹</button>
        <button type="button" onClick={onToday}>{todayLabel}</button>
        <span className="range">{label || weekRangeLabel(interval.startDate, interval.endDate)}</span>
        <button type="button" onClick={onNext} aria-label={nextLabel}>›</button>
    </div>
);

export default WeekNav;
